<template>
    <div><slot name="activator" :attrs="{}" :isNext="true" :on="{ click }" /></div>
</template>

<script>
export default {
    methods: {
        click() {
            this.$router.push(`${this.$route.path}/dashboard`);
        },
    },
};
</script>

<style>
</style>